// extracted by mini-css-extract-plugin
module.exports = {"Default":"Input_Default__CqOwS","Suffix":"Input_Suffix__2jmse","FlexContainer":"Input_FlexContainer__2ZMBE"};